export default __webpack_public_path__ + "static/media/vinitaImg.6c0a1b6f.svg";